import { useRouter } from "next/router";

import HeaderTopEight from "./Header-Top/HeaderTop-Eight";
import HeaderTopBar from "./HeaderTopBar/HeaderTopBar";
import HeaderEight from "./Headers/Header-Eight";
import DarkSwitch from "./dark-switch";
import { useAppContext } from "@/context/Context";

const HeaderStyleTen = ({
  headerSticky,
  announcements,
  brand = {
    _id: "66db0e6b9986268c3f6e50c2",
    companyName: "Thewebvale",
    phone: "+91 8770183178",
    logo: "https://ik.imagekit.io/Yash/Logo/Thewebvale-logo-black_415Mlrb_p.png?updatedAt=1726246911636",
  },
}) => {
  const { isLightTheme, toggleTheme } = useAppContext();
  const router = useRouter();

  return (
    <>
      <DarkSwitch isLight={isLightTheme} switchTheme={toggleTheme} />
      <header className="rbt-header rbt-header-10">
        {router.pathname === "/01-main-demo" &&
        "/16-udemy-affiliate" &&
        "/01-main-demo" ? (
          <HeaderTopBar />
        ) : (
          <HeaderTopEight
            brand={brand}
            announcements={announcements}
            bgColor="bg-not-transparent bg-color-darker"
            gapSpaceBetween="header-space-betwween"
            container="container-fluid"
            flexDirection=""
            btnClass="rbt-switch-btn btn-gradient btn-xs"
            btnText="Call us now"
          />
        )}
        <HeaderEight
          headerSticky={headerSticky}
          brand={brand}
          sticky="header-sticky"
          container="container-fluid"
          gapSpaceBetween="header-space-betwween"
          navigationEnd="rbt-navigation-start"
        />
      </header>
    </>
  );
};
export default HeaderStyleTen;
